// extracted by mini-css-extract-plugin
export var equalColumn = "_hi-0";